import { useState, useEffect } from "react";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { useGetProfileByIdQuery } from "../../redux/profileApiV3";
import useUserId from "./useUserId";
import { getProgrammesByProgrammeIds } from "../../utils/JourneyUtils";
/**
 * Custom React hook for returning Programmes for all of a user's past and current programme objects.
 * @returns {Array} [userPastAndCurrentProgrammes, isReady]
 */

export function useUserPastAndCurrentProgrammes() {
  const [userPastAndCurrentProgrammes, setUserPastAndCurrentProgrammes] = useState([]);
  const [isReady, setIsReady] = useState(false);
  const [userId] = useUserId();
  const { data: profile, isSuccess, isUninitialized } = useGetProfileByIdQuery(userId ?? skipToken);

  useEffect(() => {
    if (isSuccess && !isUninitialized) {
      const userPastAndCurrentProgrammes = getProgrammesByProgrammeIds(profile.pastAndCurrentProgrammeIds);
      setUserPastAndCurrentProgrammes(userPastAndCurrentProgrammes);
      setIsReady(true);
    }
  }, [profile, isSuccess, isUninitialized]);

  return [userPastAndCurrentProgrammes, isReady];
}
